import { useState } from 'react'
import { Link } from 'react-router-dom'

import AuthHeader from '../features/auth/AuthHeader'
import { reilmAPI } from '../services/apiClient'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await reilmAPI.forgotPassword({ email })
      setSent(true)
    } catch (err) {
      setError(err?.response?.data?.error?.message || 'Something went wrong. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-brand-pageFill flex flex-col">
      <AuthHeader />

      {/* M3.3: 40px from the navbar to the content, all breakpoints. */}
      <main className="flex-1 flex items-start justify-center px-6 pt-[40px]">
        <div className="w-full max-w-[576px] flex flex-col items-center gap-8">
          <h1 className="text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] font-extrabold text-brand-dark text-center w-full">
            {sent ? 'Check your inbox' : (<>Enter your email<br />to receive a reset link.</>)}
          </h1>

          {sent ? (
            <>
              <p className="text-[16px] text-brand-dark text-center max-w-[576px]">
                If an account with that email address exists, you will receive a
                link to reset your password.
              </p>
              <Link
                to="/login"
                className="text-[14px] font-semibold text-brand-primary hover:text-brand-hover"
              >
                Back to sign in
              </Link>
            </>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="w-full max-w-[416px] flex flex-col items-center gap-8"
            >
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                className="w-full h-[56px] bg-white border border-brand-fieldBdr rounded-full px-6 text-[14px] text-brand-dark placeholder:text-brand-placeholder outline-none focus:border-brand-primary"
              />

              {error && (
                <p className="text-[14px] text-red-600 font-medium text-center">
                  {error}
                </p>
              )}

              <button
                type="submit"
                disabled={submitting}
                className="w-full max-w-[264px] h-[56px] rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[16px] font-semibold disabled:opacity-60 transition-colors"
              >
                {submitting ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
          )}
          {/* M3.6.2 reverses the set #1 request: no signup cross-link on the
              password-change pages. "Back to sign in" above stays — it is the contextual
              action for this screen. */}
        </div>
      </main>
    </div>
  )
}

export default ForgotPassword
